import application from "./application.vue";
import router from "./router";
if (import.meta.env.MODE === "simple-keiri") {
  import("@/tailwind-simple-keiri.css");
} else {
  import("@/tailwind.css");
}
import { createApp } from "vue";
import "@/global.ts";

const app = createApp(application);

app.use(router);

app.mount("#app");
